// extracted by mini-css-extract-plugin
module.exports = {"logo":"HeaderLogo_logo__i_Hqs","logoWithTest":"HeaderLogo_logoWithTest__0D_3H","logoLink":"HeaderLogo_logoLink__R_8lf","customDate":"HeaderLogo_customDate__HzW_j"};